<template>
	<c-dialog
		ref="dialog"
		:title="dialogTitle"
        width="70vw"
		mode="slide"
		enable-flex
		mask-close
		:button="false"
	>
		<c-table ref="detailList" height="grow" :paging="{ size: 20 }">
			<c-table-column label="工单状态" name="status" width="80">
				<template #default="{ data }">
					<c-state dict="afterSaleOrderStateDic" tag :value="data.status"></c-state>
				</template>
			</c-table-column>
			<c-table-column label="工单编号" name="order_number" width="120">
				<template #default="{ data }">
					<c-link @click="openOrderDetail(data)">{{ data.order_number }}</c-link>
				</template>
			</c-table-column>
			<c-table-column label="工单类型" name="service_type" width="60">
				<template #default="{ data }">
					<c-state dict="serviceTypeDic" tag :value="data.service_type"></c-state>
				</template>
			</c-table-column>
			<c-table-column label="客户名称" name="customer_name" width="160"></c-table-column>
			<c-table-column label="地址" name="customer_address" min-width="400" :ellipsis="true"></c-table-column>
			<c-table-column label="出差公里数" name="travel_km" width="80">
				<template #default="{ data }">{{ fmtKm(data.travel_km) }}</template>
                <template #tip="{data}">
                    <c-tooltip>
                        <template #tip>
                            <p>根据工程师参与的工单，出发网点与客户服务地址的（驾车）距离</p>
                        </template>
                    </c-tooltip>
                </template>
			</c-table-column>
			<c-table-column label="工时" name="work_hours" width="80">
				<template #default="{ data }">{{ fmtHour(data.work_hours) }}</template>
                <template #tip="{data}">
                    <c-tooltip>
                        <template #tip>
                            <p>根据工程师的打卡时间差值计算工时，工时包含以下两部分：</p>
                            <p>1、到达打卡时间与出发打卡时间之间的时间差值：</p>
                            <p>2、下班打卡时间与上班打卡时间之间的时间差值（如果不存在上班或下班打卡，则默认工作8小时）：</p>
                        </template>
                    </c-tooltip>
                </template>
			</c-table-column>
			<c-table-column label="安装产品数" name="install_product_count" width="80">
				<template #default="{ data }">{{ fmtInstallCount(data.install_product_count) }}</template>
			</c-table-column>
            <c-table-column label="个人费用" name="personal_reimbursement_money" width="90">
                <template #default="{ data }">￥{{ data.personal_reimbursement_money != null && data.personal_reimbursement_money !== '' ? data.personal_reimbursement_money : '-' }}</template>
                <template #tip="{data}">
                    <c-tooltip align="end">
                        <template #tip>
                            当前工单费用报销中的“个人费用”
                        </template>
                    </c-tooltip>
                </template>
            </c-table-column>
            <c-table-column label="分摊费用" name="avg_public_reimbursement_money" width="90">
                <template #default="{ data }">￥{{ data.avg_public_reimbursement_money != null && data.avg_public_reimbursement_money !== '' ? data.avg_public_reimbursement_money : '-' }}</template>
                <template #tip="{data}">
                    <c-tooltip align="end">
                        <template #tip>
                            当前工单费用报销中的“分摊费用”
                        </template>
                    </c-tooltip>
                </template>
            </c-table-column>
		</c-table>
	</c-dialog>
</template>

<script>
export default {
	name: 'engineerPerformanceDetail',

	data() {
		return {
			dialogTitle: '绩效详情'
		};
	},

	methods: {
		open(data) {
			if (!data) {
				data = {};
			}
			this.dialogTitle = `${data.engineer_name || ''}-绩效详情`;
			this.$refs.dialog.open();
			this.$nextTick(() => {
				this.$refs.detailList.load({
					url: '/engineer/performance/detail/list',
					data: data.query || {},
					success: () => {}
				});
			});
		},

		openOrderDetail(data) {
			if (data && data.id != null) {
				this.globalDialog('afterSaleOrderDetail', { props: { id: data.id } });
			}
		},

		fmtHour(v) {
			if (v === null || v === undefined || v === '') {
				return '-';
			}
			return `${v}h`;
		},

		fmtKm(v) {
			if (v === null || v === undefined || v === '') {
				return '-';
			}
			return `${v}km`;
		},

		fmtInstallCount(v) {
			if (v === null || v === undefined || v === '') {
				return '-';
			}
			const n = parseFloat(v);
			if (Number.isNaN(n)) {
				return '-';
			}
			return n;
		}
	}
};
</script>

<style lang="stylus" scoped>
.perf-sum-label
	font-weight 600
</style>
